<template>
  <div id="app">
    <desktop-notice />
    <router-view />
  </div>
</template>
<script>
import { getQueryString } from '@/utils/index';
import DesktopNotice from '@/components/DesktopNotice.vue';

export default {
  name: 'app',
  components: { DesktopNotice },
  created() {
    const tmpInviteCode = getQueryString('inviteCode');
    const bindId = getQueryString('bindId');
    const h5OpenId = getQueryString('h5_openId');
    if (tmpInviteCode) {
      this.$store.commit('setInviteCode', tmpInviteCode);
    }
    if (bindId) {
      this.$store.commit('setBindId', bindId);
      console.log(bindId);
    }
    if (h5OpenId) {
      this.$store.commit('setH5OpenId', h5OpenId);
      console.log(h5OpenId);
    }
    // 如果自定义后台链接访问过
    // 则清除自定义后台链接访问的缓存配置
    const funcs = localStorage.getItem('funcs');
    if (funcs) {
      localStorage.removeItem('funcs');
      localStorage.removeItem('token');
    }
  },
};
</script>

<style lang="less">
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
}
body {
  // background-color: #f4f4f4;
  background-color: rgba(255, 255, 255, 1);
  color: #000000;
  // font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 400;
}
div {
  box-sizing: border-box;
}
img {
  max-width: 100%;

  height: auto;
}
a {
  text-decoration: none;
}
ul {
  list-style: none;
}
// #mobile_icon_div {
//   display: none !important;
// }

@media screen and (max-width: 2300px) {
  :root {
    --mentor-padding: 133.33px !important;
  }
}
@media screen and (max-width: 2000px) {

  #header {
    // padding: 0 !important;
    // justify-content: center;
    // .right {
    //   margin-left: 22.34px;
    // }

  }

  :root {
    --mentor-padding: 70px !important;
  }
}

@media screen and (max-width: 1867px) {
  .adativeItemscontainer {
  }
  .mentor-container {
    .ec-bottom {
      .item {
        flex-basis: 780px !important;
      }
      .left {
        flex-basis: 290px !important;
      }
      .tags {
        span {
          padding: 8px 16px !important;
        }
      }
    }
  }
  .app-web-site {
    .aw-header {
      padding: 0 133.33px !important;
    }
    .aw-hh-container {
    padding: 0 133.33px !important;
  }
  }
  :root {
    --newhome-padding: 133.33px !important;
  }
  #header {
    padding: 0 133.33px !important;
    .game-container {
      .content {
        padding-left: 133.33px !important;
        padding-right: 133.33px !important;
      }
    }
    // .middle {
    //   margin: 0 auto !important;
    // }
    // .right {
    //   margin: 0 auto !important;
    // }
    // .left {
    //   margin: 0 0 0 auto !important;
    // }
    .free-container {
      .flex-content {
        padding-left: 311.21875px;
        padding-right: 0;
        justify-content: center;
        >div {
          margin: 0 auto 0 0 !important;
        }
      }

    }
  }
  .classicalContainer {
    justify-content: space-between !important;
    .classicalItem {
      margin: 0 !important;
    }
  }
}

@media screen and (max-width: 1777px) {
 .ec-bottom {
  .list {
    .item {
    padding: 20px !important;
    flex-basis: 715px !important;

  }
  }

  .left {
    flex-basis: 270px !important;
  }
 }
}

@media screen and (max-width: 1734px) {
  #header {
    .middle>.el-menu {
      >.el-menu-item{
      padding: 0 20px !important;
      }
      >.el-submenu {
        .el-submenu__title {
          padding: 0 20px !important;
        }
      }
    }
    .free-container {
      .flex-content {
        padding-left: 133.33px;
        padding-right: 133.33px;
        justify-content: center;
        >div {
          margin: 0 auto 0 0 !important;
        }
      }

    }

  }
  .customercorp {
    // margin: 0 !important;
    .item {
      // margin: 0 auto !important;
    }
  }

  .fundationItemscontainer {
    .items {
      .itemcontainer {
        margin: 0 0 50px 0 !important;
        // margin-left: auto !important;
        // margin-right: auto !important;
      }
    }
  }

}
</style>
